export default __webpack_public_path__ + "static/media/Ashish Garg.43303c22.jpg";